import {
  Component,
  Input,
  forwardRef,
  EventEmitter,
  Output
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

/*##################################################################################*
 * COMPOSANT SPRO : spro-dropdownlist
 *
 * DESCRIPTION : Composant permettant l'affichage d'un dropdownlist de Kendo UI avec
 * des parametres preconfigurés
 *
 ##################################################################################*/

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => spro_cls_dropdownlist),
  multi: true
};

@Component({
  selector: "spro-dropdownlist",
  styleUrls: ["./spro-dropdownlist.component.scss"],
  template: `
    <label class="k-form-field autosize-kendo">
      <span>{{ w_label | translate }}</span>
      <kendo-dropdownlist
        [data]="h_data"
        [textField]="w_texteChamp"
        [valueField]="w_valeurChamp"
        [value]=""
        [class]="w_class"
        [(ngModel)]="a_selectedData"
        (valueChange)="proc_valueChange($event)"
        [disabled]="!f_actif"
      >
        <ng-template
          kendoDropDownListItemTemplate
          let-dataItem
          *ngIf="f_aff_clef_liste"
        >
          {{ proc_getLib(dataItem) }}
        </ng-template>

        <ng-template
          kendoDropDownListValueTemplate
          let-dataItem
          *ngIf="f_aff_clef_valeur"
        >
          {{ proc_getLib(dataItem) }}
        </ng-template>
      </kendo-dropdownlist>
    </label>
  `
})
export class spro_cls_dropdownlist {
  /** Liste de données */
  @Input() h_data: Array<any>;
  /** Libellé des données */
  @Input() w_texteChamp: string;
  /** Clef des données */
  @Input() w_valeurChamp: string;
  /** Texte avant le composant */
  @Input() w_label: string;
  /** Valeur par défaut */
  @Input() a_selectedData: any;
  /** Affiché la clef + libellé dans la valeur sélectionné */
  @Input() f_aff_clef_valeur: boolean = false;
  /** Affiché la clef + libellé dans toute la liste */
  @Input() f_aff_clef_liste: boolean = false;
  /** Pour désactiver la combo */
  @Input() f_actif: boolean = true;
  /** Label contenant la classe utilisé pour le style de la zone */
  @Input() w_class: string = "autosize-kendo form-control";

  /** Evénements sur changement de valeur */
  @Output() e_valueChange: EventEmitter<any> = new EventEmitter();

  /**
   * Evénements sur changement de valeur
   */
  public proc_valueChange(value): void {
    this.e_valueChange.emit(value);
  }

  /**
   * Retourne le texte d'un template personnalisé
   */
  public proc_getLib(h_data: any): string {
    if (h_data == null) return "";

    if (h_data[this.w_texteChamp] == null) return h_data[this.w_valeurChamp];
    if (h_data[this.w_texteChamp] === "") return h_data[this.w_valeurChamp];

    return h_data[this.w_valeurChamp] + " - " + h_data[this.w_texteChamp];
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/inputs/spro-dropdownlist/spro-dropdownlist.component.ts